// Podział treści maila z edytora Jodit na część dla AI i część chronioną.
// AI (tryb kreatywny, uładnienie, korekta) dostaje i nadpisuje tylko treść pisaną przez usera -
// stopka skrzynki (div.intum_footer), cytowana wiadomość (div.intum_reply) i marker {{footer}}
// z szablonów zostają nietknięte. Za odpowiedzią AI wraca wszystko od pierwszej stopki/cytatu
// do końca treści (razem z odstępami i tekstem pod cytatem).

const PRESERVED_MARKERS = ["intum_footer", "intum_reply"]
const FOOTER_PLACEHOLDER_RE = /^\{\{\s*footer\s*\}\}$/

const ELEMENT_NODE = 1
const TEXT_NODE = 3
const COMMENT_NODE = 8

function escapeHtml(text) {
  return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
}

function matchesMarker(node, marker) {
  return Boolean(node.classList?.contains(marker)) || node.id === marker
}

// Węzeł najwyższego poziomu, od którego zaczyna się część chroniona: stopka, cytat albo marker
// {{footer}}. Sprawdzamy tylko najwyższy poziom - stopka zagnieżdżona w tabeli/wrapperze szablonu
// nie jest wykrywana i cała treść idzie do AI jak wcześniej.
export function isPreservedNode(node) {
  if (!node) return false

  if (node.nodeType === ELEMENT_NODE && PRESERVED_MARKERS.some((marker) => matchesMarker(node, marker))) return true
  if (node.nodeType !== ELEMENT_NODE && node.nodeType !== TEXT_NODE) return false

  return FOOTER_PLACEHOLDER_RE.test((node.textContent || "").trim())
}

function nodeHtml(node) {
  if (node.nodeType === ELEMENT_NODE) return node.outerHTML || ""
  if (node.nodeType === TEXT_NODE) return escapeHtml(node.textContent || "")
  if (node.nodeType === COMMENT_NODE) return `<!--${node.textContent || ""}-->`
  return ""
}

// Dzieli węzły najwyższego poziomu treści edytora na { body, bodyText, preserved }.
// Podział jest w miejscu pierwszego chronionego węzła: wszystko od niego do końca (razem
// z <br> między stopką a cytatem i tekstem pod cytatem) wraca do maila bez zmian.
// bodyText to sam tekst części dla AI - do sprawdzenia, czy jest co poprawiać.
export function splitPreservedContent(nodes) {
  const list = Array.from(nodes || [])
  let index = list.findIndex((node) => isPreservedNode(node))
  if (index === -1) index = list.length

  const bodyNodes = list.slice(0, index)
  return {
    body: bodyNodes.map(nodeHtml).join(""),
    bodyText: bodyNodes.filter((node) => node.nodeType !== COMMENT_NODE).map((node) => node.textContent || "").join(""),
    preserved: list.slice(index).map(nodeHtml).join(""),
  }
}

const ENDS_WITH_BLOCK_RE = /<\/(?:p|div|ul|ol|table|blockquote|h[1-6])>\s*$|<br\s*\/?>\s*$/i

// Skleja odpowiedź AI z chronioną częścią maila (stopka/cytat za treścią). Gdy odpowiedź kończy się
// zwykłym tekstem, wstawiamy <br>, żeby nie przykleiła się do stopki.
export function mergeAiContent(aiHtml, preserved) {
  const content = aiHtml || ""
  if (!preserved) return content

  const separator = content && !ENDS_WITH_BLOCK_RE.test(content) ? "<br>" : ""
  return `${content}${separator}${preserved}`
}

// Wersja dla przeglądarki: HTML edytora -> { body, bodyText, preserved }.
export function splitEditorHtml(html) {
  const container = document.createElement("div")
  container.innerHTML = html || ""
  return splitPreservedContent(container.childNodes)
}
